import React from "react";
import Tab from "@mui/material/Tab";
import makeStyles from "@mui/styles/makeStyles";
var useStyles = makeStyles(function (_a) {
    var pxToRem = _a.typography.pxToRem, spacing = _a.spacing, shape = _a.shape, grey = _a.palette.grey;
    return ({
        tab: {
            border: "".concat(pxToRem(1), " solid ").concat(grey[500]),
            borderRadius: shape.borderRadius,
            margin: spacing(1, 0.5),
            minHeight: "auto",
            minWidth: spacing(0),
            textTransform: "none",
            padding: spacing(0.9, 1.5),
            opacity: 0.7,
        },
    });
});
export default (function (_a) {
    var icon = _a.icon, label = _a.label, title = _a.title, onClick = _a.onClick;
    var classes = useStyles();
    return (React.createElement(Tab, { icon: icon, title: title, 
        // setting data-id to tab, so that we can capture the event when tab is clicked
        label: React.createElement("div", { "data-id": "tab" }, label), onClick: onClick, className: classes.tab }));
});
//# sourceMappingURL=Item.js.map